import {useAppSelector} from "../../../redux/hooks";
import {
  MySongsPageSortColumnType,
  MySongsPageSortDirectionType,
  mySongsPageSorters
} from "../../../config/my-songs-page-sort";
import {mySongsPageStore,} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";

export interface IFilterSortDirectionLogic {
  value: MySongsPageSortDirectionType;
  options: MySongsPageSortDirectionRadioOptionType;
  onChangeHandler: (newValue: MySongsPageSortDirectionType) => void;
}

export type MySongsPageSortDirectionRadioOptionType = {
  label: string;
  value: MySongsPageSortDirectionType;
}[];

const getMySongsPageActiveSortDisplayDirectionOptions = function (activeSortColumn:  MySongsPageSortColumnType): MySongsPageSortDirectionRadioOptionType {
  const activeSorter = mySongsPageSorters.get(activeSortColumn);

  if (activeSorter?.hideSortOrderControls) {
    return [];
  }

  const defaultDirection = activeSorter?.defaultDirection;
  const options: MySongsPageSortDirectionRadioOptionType = [
    {
      label: mySongsPageSorters.getSortDirectionLabel(mySongsPageStore.getSortColumn(), `asc`),
      value: `asc`,
    },
    {
      label: mySongsPageSorters.getSortDirectionLabel(mySongsPageStore.getSortColumn(), `desc`),
      value: `desc`,
    }
  ];
  // Put the default option first
  return options.sort((optionA, _) => optionA.value === defaultDirection ? -1 : 0);
};

export const useFilterSortDirectionLogic = (): IFilterSortDirectionLogic => {
  const activeSortColumn = useAppSelector(mySongsPageStore.getSortColumn);
  const options = getMySongsPageActiveSortDisplayDirectionOptions(activeSortColumn);
  const value = useAppSelector(mySongsPageStore.getSortDirection);

  return {
    value,
    options,
    onChangeHandler: (sortDirection: MySongsPageSortDirectionType) => mySongsPageStore.setSortDirection(sortDirection),
  };
}
